import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

const AgenticAiAlert = () => {
  const { t } = useTranslation('@mint-lib/agentic-ai-circuit');
  return (
    <p
      className={cn(
        typographyVariants({
          color: 'tertiary',
          variant: 'bodyShort01',
        }),
        'mb-5 self-center',
      )}
      aria-label="agentic-alert"
    >
      {t(
        "You're interacting with an AI system that can make mistakes. Please consider checking important information",
      )}
    </p>
  );
};

export default AgenticAiAlert;
